import { useQuery } from "@tanstack/react-query";
import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import {
  DemandCompaniesResponse,
  HttpResponse,
  GetDemandCompaniesParams,
} from "@/types";

export function useGetDemandCompanies(
  params: GetDemandCompaniesParams,
) {
  return useQuery({
    queryKey: ["demand/companies", params],
    queryFn: async () => {
      const queryParams = misc.prepareQueryParams({
        ...params,
      });
      // Query params are for pagination and search query.
      const path = `demand/companies?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        DemandCompaniesResponse,
        HttpResponse<DemandCompaniesResponse>
      >(path);
      return res.data;
    },
    placeholderData: (previousData) => previousData,
  });
}

